// extracted by mini-css-extract-plugin
export default {"logo":"root_logo-module__logo___JjEbT","logoDesktop":"root_logo-module__logoDesktop___s2mv0","logoTouch":"root_logo-module__logoTouch___R3LPT"};